<template>
  <div class="dashboard-components">
    <div class="dashboard-p3-content">
      <el-select v-model="type" placeholder="请选择" size="mini" @change="initData()" popper-class="singlecodetopselect">
        <el-option
          class="barchart-miniselector"
          v-for="item in typeoptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <div id="scatter" class="dashboard-p3-scatter-item">1</div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
			type: 0,
      unit: '',
			typeoptions: [{
				label: this.$t('SingleCodeAnalysis.t08'),
				value: 0
			},{
				label: this.$t('SingleCodeAnalysis.t07'),
				value: 1
			},{
				label: this.$t('SingleCodeAnalysis.t06'),
				value: 2
			},{
				label: '当月',
				value: 3
			}],
      chartdata: [
        [
          [77, 28604, 17096869, '白酒', 1990],
          [77.4, 31163, 27662440, '龙舌兰', 1990],
          [68, 1516, 1154605773, '威士忌', 1990],
          [74.7, 13670, 10582082, '伏特加', 1990],
          [75, 28599, 4986705, '散装葡萄酒', 1990],
        ], [
          [81.8, 44056, 23968973, '白酒', 2015],
          [81.7, 43294, 35939927, '龙舌兰', 2015],
          [76.9, 13334, 1376048943, '威士忌', 2015],
          [78.5, 21291, 111389562, '伏特加', 2015],
          [80.8, -38923, 355503457, '散装葡萄酒', 2015],
        ]
      ]
    }
  },

  mounted(){
    this.initData()
  },

  methods: {

    /**
     * 初始化数据
     */
    initData: function(){
      this.initScatter('scatter')
    },

    /**
     * 散点图
     */
    initScatter: function(id){
      let that = this
      let myBarChart = this.echarts.init(document.getElementById(id))
      myBarChart.clear()
      myBarChart.setOption({
        title: {
          text: '圆圈大小代表贸易伙伴的进口数量',
          textStyle: {
            color: '#ffffff',
            fontWeight: 'normal',
            fontSize: 12,
          },
          bottom: 10,
          left: 90
        },
        legend: {
          right: 30,
          top: 60,
          orient: 'vertical',
          data: ['葡萄酒', '啤酒'],
          textStyle: {
            color: '#ffffff'
          }
        },
        grid: {
          left: 100,
          top: 30,
          bottom: 60,
        },
        tooltip: {
          padding: 0,
          backgroundColor: 'rgba(50,50,50,0)',
          borderColor: 'rgba(50,50,50,0)',
          borderWidth: 0,
          formatter: function (obj) {
            return '<div style="padding:10px; min-width:200px; border-radius: 20px; background-color: rgba(50,50,50,0.8);">'
              + '<h2 style="font-size:16px; font-weight:normal; padding-bottom:10px; text-align: left;">' + obj.data[3] + '</h2>'
              + '<h3 style="font-size:12px; font-weight:normal; border-top:1px solid #ddd; line-height:36px;">' + that.tooltip1 + '<span style="float:right;">'+ that.millonFormat(obj.data[0]) +'%</span></h3>'
              + '<h3 style="font-size:12px; font-weight:normal; border-top:1px solid #ddd; line-height:36px;">' + that.tooltip2 + '<span style="float:right;">'+ that.millonFormat(obj.data[1]) + ' ' + obj.data[6] + '</span></h3>'
              + '<h3 style="font-size:12px; font-weight:normal; border-top:1px solid #ddd; line-height:36px;">' + that.tooltip3 + '<span style="float:right;">'+ that.millonFormat(obj.data[7]) + ' ' + obj.data[6] + '</span></h3>'
              + '</div>'
              + '<div style="margin:auto; width: 0; height: 0; border-left: 20px solid transparent; border-right: 20px solid transparent; border-top: 20px solid rgba(50,50,50,0.8);"></div>'
          },
          position: function (point) {
            return [point[0] - 100, point[1] - 190]
          }
        },
        xAxis: {
          name: '细分类别份额 % - 滚动年累',
          nameLocation: 'middle',
          nameGap: '30',
          axisLine: { 
            show: true,
            lineStyle: {
              color: '#FFFFFF',
            },
            onZero: true
          },
          splitLine: {
            lineStyle: {
              type: 'dotted',
              color: 'rgba(255, 255, 255, 0.2)'
            }
          },
          axisLabel: {
            formatter: function(value){
              return value + '%'
            }
          },
          axisTick: {
            show: false
          },
        },
        yAxis: {
          name: '进口数量同比增加值 (百万升) – 滚动年累计',
          nameLocation: 'middle',
          nameGap: '80',
          nameRotate: '90',
          axisLine: { 
            show: false,
            lineStyle: {
              color: '#ffffff',
            },
            onZero: false
          },
          splitLine: {
            lineStyle: {
              type: 'dotted',
              color: 'rgba(255, 255, 255, 0.2)'
            }
          },
          axisTick: {
            show: false
          },
          scale: true
        },
        series: [
          {
            name: '葡萄酒',
            data: that.chartdata[0],
            type: 'scatter',
            symbolSize: function (data) {
              return Math.sqrt(data[2]) / 5e2;
            },
            emphasis: {
              focus: 'series',
              label: {
                show: true,
                formatter: function (param) {
                  return param.data[3];
                },
                position: 'top'
              }
            },
          },
          {
            name: '啤酒',
            data: that.chartdata[1],
            type: 'scatter',
            symbolSize: function (data) {
              return Math.sqrt(data[2]) / 5e2;
            },
            emphasis: {
              focus: 'series',
              label: {
                show: true,
                formatter: function (param) {
                  return param.data[3];
                },
                position: 'top'
              }
            },
          }
        ],
        color: ['rgb(0,148,115)', 'rgb(51,102,153)', 'rgb(240,192,90)', 'rgb(190,69,116)', 'rgb(112,48,160)', 'rgb(150,79,76)']
      })
      $(window).resize(function () {
        myBarChart.resize()
      })
    },
  }
}
</script>